<script setup lang="ts"></script>

<template>
  <v-layout>
    <v-main class="ma-0">
      <NuxtPage :page-key="(route) => route.path" />
    </v-main>
  </v-layout>
</template>
